
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

interface LearningChatResponse {
  answer: string;
  mode: 'tutoring' | 'explanatory';
}

export const learningAPI = {
  chat: async (message: string, conversationHistory: ChatMessage[], studentInfo: any): Promise<LearningChatResponse> => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/learning/chat`, {
        message,
        conversation_history: conversationHistory,
        student_info: studentInfo
      });
      return response.data;
    } catch (error) {
      console.error('Learning API error:', error);
      throw error;
    }
  }
};
